"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import type { Entry } from "contentful";
import { BlogBreadcrumb } from "@/components/custom/Blog/BlogBreadcrumb";
import { BlogArticleBody } from "@/components/custom/BlogArticle/BlogArticleBody";
import { BlogArticleFooter } from "@/components/custom/BlogArticle/BlogArticleFooter";
import { BlogArticleHeader } from "@/components/custom/BlogArticle/BlogArticleHeader";
import { BlogArticleNavigation } from "@/components/custom/BlogArticle/BlogArticleNavigation";
import { JsonLd } from "@/components/custom/JsonLd";
import { SITE_URL } from "@/constants/siteUrl";
import { buildBlogPostingJsonLd } from "@/lib/blog-jsonld";
import { getEntry } from "@/lib/contentful/guards";
import type { AdjacentPosts } from "@/types/contentful/AdjacentPosts";
import type { TypeBlogArticleSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
interface Props {
  initialData: Entry<TypeBlogArticleSkeleton, undefined, string>;
  adjacentPosts: AdjacentPosts;
}
export default function BlogArticleClient(t0) {
  const $ = _c(36);
  const {
    initialData,
    adjacentPosts
  } = t0;
  const liveData = useContentfulLiveUpdates(initialData);
  const {
    headline,
    publishedDate,
    introSummary,
    author,
    featuredImage,
    bodyContent,
    categories
  } = liveData.fields;
  let resolvedAuthor;
  let resolvedImage;
  let t1;
  if ($[0] !== author || $[1] !== featuredImage) {
    resolvedImage = getEntry(featuredImage);
    let t2;
    if ($[5] !== author) {
      t2 = getEntry(author);
      $[5] = author;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    resolvedAuthor = t2;
    t1 = ContentfulHelper.parseContentfulContentImage(resolvedImage?.fields.media);
    $[0] = author;
    $[1] = featuredImage;
    $[2] = resolvedAuthor;
    $[3] = resolvedImage;
    $[4] = t1;
  } else {
    resolvedAuthor = $[2];
    resolvedImage = $[3];
    t1 = $[4];
  }
  const imageData = t1;
  let t2;
  if ($[7] !== liveData) {
    t2 = buildBlogPostingJsonLd(liveData, {
      includeContext: true,
      baseUrl: SITE_URL
    });
    $[7] = liveData;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <JsonLd data={t2} />;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = `${SITE_URL}/blog/${liveData.fields.slug}`;
  let t5;
  if ($[11] !== headline || $[12] !== t4) {
    t5 = <BlogBreadcrumb currentPage={headline} url={t4} />;
    $[11] = headline;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = resolvedImage?.sys.id;
  let t7;
  if ($[14] !== headline || $[15] !== imageData || $[16] !== introSummary || $[17] !== publishedDate || $[18] !== t6) {
    t7 = <BlogArticleHeader headline={headline} introSummary={introSummary} publishedDate={publishedDate} image={imageData} imageEntryId={t6} />;
    $[14] = headline;
    $[15] = imageData;
    $[16] = introSummary;
    $[17] = publishedDate;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== bodyContent) {
    t8 = <BlogArticleBody bodyContent={bodyContent} />;
    $[20] = bodyContent;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== categories || $[23] !== resolvedAuthor) {
    t9 = <BlogArticleFooter author={resolvedAuthor} categories={categories} draftMode={true} />;
    $[22] = categories;
    $[23] = resolvedAuthor;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== adjacentPosts) {
    t10 = <BlogArticleNavigation adjacentPosts={adjacentPosts} />;
    $[25] = adjacentPosts;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t11 = <article className="flex flex-col animate-in fade-in slide-in-from-top-4 duration-500">{t7}{t8}{t9}{t10}</article>;
    $[27] = t10;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t3 || $[34] !== t5) {
    t12 = <>{t3}{t5}{t11}</>;
    $[32] = t11;
    $[33] = t3;
    $[34] = t5;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}